import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

/*
 * Tema corporativo de IMJ Media.
 *
 * TODO(ux-ui): la paleta y las formas son un PLACEHOLDER pendiente de confirmar
 * con el grupo de ux-ui. Sustituir por la paleta oficial cuando esté aprobada.
 * Los valores del tema oscuro son derivados (primario más claro para mantener
 * el contraste sobre fondo oscuro) y también están pendientes de validación.
 */

const FUENTE_IMJ = 'Inter, Helvetica, Arial, sans-serif';

/** Barra lateral: se mantiene oscura en ambos modos para reforzar la marca. */
const navegacionIMJ = {
  background: '#0B1F2E',
  indicator: '#E8792B',
  color: '#B8C7D4',
  selectedColor: '#FFFFFF',
  navItem: { hoverBackground: '#163A52' },
  submenu: { background: '#0E2636' },
};

const paletaClara = {
  ...palettes.light,
  primary: { main: '#0F3D5E' },
  secondary: { main: '#E8792B' },
  navigation: navegacionIMJ,
};

const paletaOscura = {
  ...palettes.dark,
  // Primario aclarado para legibilidad sobre fondo oscuro (pendiente ux-ui).
  primary: { main: '#8CC4EC' },
  secondary: { main: '#E8792B' },
  navigation: navegacionIMJ,
};

/** Cabeceras de página por tipo; `home` es la predeterminada. */
const paginasIMJ = {
  home: genPageTheme({ colors: ['#0F3D5E', '#0B1F2E'], shape: shapes.wave }),
  documentation: genPageTheme({
    colors: ['#1B5E7F', '#0F3D5E'],
    shape: shapes.wave2,
  }),
  tool: genPageTheme({ colors: ['#E8792B', '#B5520F'], shape: shapes.round }),
  service: genPageTheme({
    colors: ['#2C6E8F', '#0B1F2E'],
    shape: shapes.wave,
  }),
  website: genPageTheme({
    colors: ['#3A7CA5', '#0F3D5E'],
    shape: shapes.wave,
  }),
  library: genPageTheme({
    colors: ['#5B7083', '#2E3B47'],
    shape: shapes.wave,
  }),
  other: genPageTheme({ colors: ['#4A4A4A', '#262626'], shape: shapes.square }),
  app: genPageTheme({ colors: ['#0B1F2E', '#0F3D5E'], shape: shapes.wave }),
  apis: genPageTheme({
    colors: ['#1F7A6D', '#0F3D5E'],
    shape: shapes.wave2,
  }),
};

export const imjLight = createUnifiedTheme({
  palette: paletaClara,
  defaultPageTheme: 'home',
  pageTheme: paginasIMJ,
  fontFamily: FUENTE_IMJ,
});

export const imjDark = createUnifiedTheme({
  palette: paletaOscura,
  defaultPageTheme: 'home',
  pageTheme: paginasIMJ,
  fontFamily: FUENTE_IMJ,
});
